// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__BwWj9","inner":"Form_inner__16C0E","range":"Form_range__2g7C0","name":"Form_name__1Kkqf","actions":"Form_actions__3LSft"};